// ── Nav overflow → compact mode + scroll-edge fade ──────────────────
(function () {
    'use strict';

    var navBand  = document.querySelector('.nav-band');
    var navLinks = document.getElementById('frame-nav-links');

    // Drives the mask gradient in nav.css: fade in on the left once
    // scrolled, fade out on the right once the end is reached.
    function updateNavFade() {
        var max  = navLinks.scrollWidth - navLinks.clientWidth;
        var left = navLinks.scrollLeft;
        navLinks.style.setProperty('--fade-l', left > 1 ? 'var(--fade)' : '0px');
        navLinks.style.setProperty('--fade-r', left < max - 1 ? 'var(--fade)' : '0px');
    }

    function updateNavCompact() {
        // Measure in non-compact state so the decision is stable (compact
        // mode shrinks the content, which would otherwise flip-flop).
        navBand.removeAttribute('data-nav-compact');
        if (navLinks.scrollWidth > navLinks.clientWidth + 1) {
            navBand.setAttribute('data-nav-compact', '');
        }
        updateNavFade();
    }

    if (navBand && navLinks) {
        updateNavCompact();
        window.addEventListener('resize', updateNavCompact);
        navLinks.addEventListener('scroll', updateNavFade, { passive: true });
        if (window.ResizeObserver) {
            new ResizeObserver(updateNavFade).observe(navLinks);
        }
        // Keep keyboard focus out of the faded zones — scroll-padding-inline
        // on .nav-links makes 'nearest' land past the fade. block: 'nearest'
        // avoids vertical page scrolling.
        navLinks.addEventListener('focusin', function (e) {
            e.target.scrollIntoView({ block: 'nearest', inline: 'nearest' });
        });
        if (document.fonts && document.fonts.ready) {
            document.fonts.ready.then(updateNavCompact);
        }
    }
})();
